import * as elements from '../UiElements';

export const showSummary = (recipe) => {
  elements.loafNum.innerHTML = `${recipe.numLoaves} ${
    recipe.numLoaves > 1 ? 'loaves' : 'loaf'
  }`;

  elements.loafMass.innerHTML = `${Math.round(
    recipe.doughMass / recipe.numLoaves
  )}g`;

  elements.loafHydration.innerHTML = `${Math.round(
    recipe.bakersHydration * 100
  )}% hydration`;

  setLabelStats(recipe);
};

export const showSummaryChanger = (e) => {
  hideSummaryChanger();
  if (e.target === elements.loafNum) {
    elements.loafNum.classList.add('shadow');
    elements.loafNumEditor.classList.toggle('hidden');
    elements.loafNumInput.focus();
  } else if (e.target === elements.loafMass) {
    elements.loafMass.classList.add('shadow');
    elements.loafMassEditor.classList.toggle('hidden');
    elements.loafMassInput.focus();
  } else if (e.target === elements.loafHydration) {
    elements.loafHydration.classList.add('shadow');
    elements.loafHydrationEditor.classList.toggle('hidden');
    elements.loafHydrInput.focus();
  } else {
    hideSummaryChanger();
  }
  toggleTiptext();
};

export const saveSummaryChange = (e) => {};

export const hideSummaryChanger = () => {
  Array.from(document.querySelectorAll('.dough-summary')).forEach((e) => {
    e.classList.add('hidden');
  });
  Array.from(elements.summarySection.children).forEach((e) =>
    e.classList.remove('shadow')
  );
  clearAllInputs();
  toggleTiptext();
};

export const clearAllInputs = () => {
  elements.summaryInputsArr.forEach((e) => (e.value = ''));
};

export const toggleTiptext = () => {
  if (
    elements.loafNumEditor.classList.contains('hidden') &&
    elements.loafMassEditor.classList.contains('hidden') &&
    elements.loafHydrationEditor.classList.contains('hidden')
  ) {
    elements.tiptextArrAll.forEach((e) => e.classList.remove('hidden'));
  } else {
    elements.tiptextArrAll.forEach((e) => e.classList.add('hidden'));
  }
};

export const setLabelStats = (recipe) => {
  elements.endHydrationLabel.innerHTML = `End hydration with levain is ${Math.round(
    recipe.endHydration * 100
  )}%`;
  if (recipe.numLoaves > 1) {
    elements.totalDoughMassLabel.innerHTML = ` • Total dough ${Math.round(
      recipe.doughMass
    )}g`;
  } else {
    elements.totalDoughMassLabel.innerHTML = ``;
  }
};
